import { useCallback, useEffect, useState } from 'react';
import { getReassignScenarios } from 'api/group';
import { TReassignScenarioRsp } from 'types/group';

export default function useReassignScenarios(
    appointmentId?: number,
): [TReassignScenarioRsp | undefined, boolean, () => void] {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<TReassignScenarioRsp>();

    const fetchData = useCallback(async () => {
        if (!appointmentId) return;
        setLoading(true);
        try {
            const result = await getReassignScenarios(appointmentId);
            if (!result.error) {
                setData(result.data?.data);
            }
        } finally {
            setLoading(false);
        }
    }, [appointmentId]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data, loading, fetchData];
}
